import { styled } from "@mui/material";

export default function PriceProductCard({ children }) {
	const StyledComponent = styled("h6")(({ theme }) => ({
		fontFamily: "Fjalla One",
		fontSize: "0.9rem",
		color: theme.palette.secondary.main,
		opacity: 0.9,
		margin: 0,
		[theme.breakpoints.down("sm")]: {
			fontSize: "1rem",
		},
	}));

	return <StyledComponent>{children}</StyledComponent>;
}
